import { Loader2 } from "lucide-react"

import { StepHeader, WizardLayout } from "@/components/agents/setup/shell"
import { Button } from "@/components/ui/button"

import { useStepSave } from "./nav"
import { ReviewPreview } from "./review-preview"
import type { ReviewResponderStepProps } from "./types"

// IMP-439: the "Recent unanswered reviews" starting point is hidden for launch —
// the agent always starts from new reviews only (no last-30-days backfill). The
// choice is removed for now; the server also locks starting_point to "new-only"
// on write. Re-enabling is a UI change.
export function LaunchStep({
  agent,
  stepNumber,
  totalSteps,
  exampleSet,
}: ReviewResponderStepProps) {
  const { processing, save } = useStepSave(agent.uid)

  function launch() {
    save("step-launch", { starting_point: "new-only" }, { complete: true })
  }

  return (
    <WizardLayout
      footer={
        <>
          <Button
            variant="outline"
            onClick={() =>
              save("step-customization", { starting_point: "new-only" })
            }
            disabled={processing}
          >
            Back
          </Button>
          <Button onClick={launch} disabled={processing}>
            {processing && <Loader2 className="size-4 animate-spin" />}
            {processing ? "Launching…" : "Launch"}
          </Button>
        </>
      }
    >
      <StepHeader
        eyebrow={`Step ${stepNumber} of ${totalSteps}`}
        title="Test and go live"
        description="Review your configuration, then launch. The agent responds to new reviews from now on, and you can change any of this later."
      />

      <ReviewPreview
        agentUid={agent.uid}
        exampleReviews={exampleSet?.preview_reviews ?? null}
      />
    </WizardLayout>
  )
}
